import { Fragment, useState, useEffect } from "react";
import { set_store } from "../../../../redux/actions/CreateStoreAction";
import { set_page_state } from "../../../../redux/actions/PageStateAction";
import { connect } from "react-redux";
import { apiJson } from "../../../../api/Api";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { Redirect } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { dateFormatter, dateTimeFormat } from "./formatter";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import JSZip from "jszip";
import { FileUploadPromise } from "../../../../utils/aws_s3/aws_s3";

const TermsAndConditionsSchema = Yup.object().shape({
  termsandcondition: Yup.boolean().required("Accept Terms and conditions"),
});

const TermsAndConditionsForm = (props) => {
  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [redirectToMessage, setRedirectToMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(null);
  const [hasViewedFullPdf, setHasViewedFullPdf] = useState(true);
  const [arrayBuffer, setArrayBuffer] = useState();

  const date = new Date();
  let message = "";
  const data = [
    dateFormatter(),
    props.store.name_en,
    props.store.store_address || "",
    `${props.store.authorized_signatory_name_en}`,
    props.store.business_name?.toUpperCase(),
    props.store.name_en,
    "",
    props.store.business_name,
    `${props.store.authorized_signatory_name_en}`,
    dateTimeFormat(),
    "",
    "",
    "",
    `${props.user.first_name_en} ${props.user.last_name_en}`.toUpperCase(),
  ];

  const docxURL =
    "https://alisuq-production-s3-bucket.s3.me-south-1.amazonaws.com/media/PDF/Contract/Alisuq_vendor_agreement.docx";

  useEffect(() => {
    const fetchDocx = async () => {
      try {
        const response = await fetch(docxURL);

        const arrayBuffer = await response.arrayBuffer();
        setArrayBuffer(arrayBuffer);
      } catch (error) {
        console.error("Error fetching DOCX file:", error);
      }
    };

    fetchDocx();
  }, []);

  const modifyPdf = async (values) => {
    const zip = await JSZip.loadAsync(arrayBuffer);

    try {
      const docXml = await zip.file("word/document.xml").async("string");

      let updatedXml = docXml;
      data.forEach((value, i) => {
        updatedXml = updatedXml.replace(/_{6,}/, value);
      });

      zip.file("word/document.xml", updatedXml);

      const updatedDocx = await zip.generateAsync({
        type: "blob",
        mimeType:
          `application/ALISUQ_VENDOR_AGREEMENT-${props.store.name_en.split(" ").join('_')}.docx`,
      });

      FileUploadPromise(updatedDocx)
        .then((response) => {
          handleCreateStore(values, response.location);
        })
        .catch((error) => {
          message = error
            ? error !== ""
              ? error
              : "something went wrong"
            : "something went wrong";
          showError();
        });
    } catch (error) {
      return error;
    }
  };

  const pdfUrl =
    "https://alisuq-production-s3-bucket.s3.me-south-1.amazonaws.com/media/PDF/Contract/vendor_agreement.pdf";

  const handlePageChange = (e) => {
    setCurrentPage(e.currentPage);
  };

  const handleDocumentLoad = (e) => {
    setTotalPages(e.doc._pdfInfo.numPages - 1);
  };

  useEffect(() => {
    if (currentPage === totalPages) {
      setHasViewedFullPdf(false);
    }
  }, [currentPage, totalPages]);

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  const showSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const submitClick = (values) => {
    setRedirectToMessage(false);
    setLoading(true);
    modifyPdf(values);
  };

  const handleCreateStore = (values, url) => {
    apiJson.createStore
      .updateStoreTermsConditions({
        store: {
          sender_email: props.store.contact_email,
          agreement_policy_accepted: values,
          agreement_policy_url: url,
          agreement_policy_accepted_at: date,
          agreement_policy_accepted: termsAndConditions,
        },
      })
      .then((response) => {
        if (response.success) {
          props.set_store({ store: {} });
          localStorage.clear();
          setLoading(false);
          message = "Your application received";
          showSuccess();
          setRedirectToMessage(true);
          props.set_page_state({ pageState: {} });
        } else if (!response.status) {
          setRedirectToMessage(false);
          setLoading(false);
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        } else {
          setRedirectToMessage(false);
          setLoading(false);
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : "something went wrong";
            showError();
          } else {
            setLoading(false);
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
  };

  const renderPage = (props) => {
    return currentPage === 0 ? (
      <>
        {props.canvasLayer.children}
        <div
          style={{
            display: "flex",
            height: "100%",
            left: "25.5%",
            position: "absolute",
            top: "14.1%",
            width: "100%",
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: "10px",
              background: "white",
              height: "30px",
            }}
          >
            {dateFormatter()}
          </div>
        </div>
        {props.annotationLayer.children}
        {props.textLayer.children}
      </>
    ) : (
      <>
        {props.canvasLayer.children}
        {props.annotationLayer.children}
        {props.textLayer.children}
      </>
    );
  };

  return (
    <Fragment>
      <Formik
        initialValues={termsAndConditions}
        // validationSchema={TermsAndConditionsSchema}
        isValidating={true}
        enableReinitialize={true}
        onSubmit={submitClick}
      >
        {() => {
          return (
            <Form className="form mx-auto">
              <div
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.3)",
                  height: "600px",
                }}
              >
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.5.207/build/pdf.worker.min.js">
                  <Viewer
                    fileUrl={pdfUrl}
                    enableSmoothScroll
                    onPageChange={handlePageChange}
                    onDocumentLoad={handleDocumentLoad}
                    renderPage={renderPage}
                  />
                  <input
                    type="checkbox"
                    onChange={(e) => setTermsAndConditions(e.target.checked)}
                    checked={termsAndConditions}
                    disabled={hasViewedFullPdf}
                    style={{ marginTop: "15px" }}
                  />
                  &nbsp;&nbsp; I agree and accept the terms and conditions.{" "}
                </Worker>
              </div>

              <br />
              <br />
              <button
                style={{ marginLeft: "auto" }}
                key={64043}
                type="submit"
                className="submit-button"
                disabled={loading || !termsAndConditions}
              >
                {!loading ? (
                  "Submit"
                ) : (
                  <ClipLoader color="#fff" loading size={20} />
                )}
              </button>
            </Form>
          );
        }}
      </Formik>

      {redirectToMessage && <Redirect to="/message" />}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    store: state.store.store,
    user: state.auth.user,
  };
};

const mapDispatchTopProps = { set_store, set_page_state };

export default connect(
  mapStateToProps,
  mapDispatchTopProps
)(TermsAndConditionsForm);
